import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  dialog: css`
    z-index: 3;
  `,
  content: css`
    max-height: 90vh;
    display: flex;
    flex-direction: column;

    & > div:first-of-type {
      z-index: 2;
    }
  `,
  body: css`
    position: relative;
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  footer: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    align-self: flex-end;
    gap: 12px;
    padding-top: 24px;
  `,
  editorContainer: css`
    flex: 1;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 520px;
    gap: 14px;
  `,
  editorWrapper: css`
    position: relative;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;

    max-height: calc(90vh - 320px);
  `,
  previewAsCandidateContainer: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  `,
  message: css`
    padding-bottom: 24px;
  `,
  toolbar: css`
    padding: 0 8px 8px;
  `,
  title: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
  `,
  bodyContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    min-height: 0;
    gap: 12px;

    svg {
      flex-shrink: 0;
    }
  `,
  error: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 300px;
    background: ${theme.colors.neutral.variant[0]};
  `,
  tryAgainButton: css`
    display: flex;
    margin-top: 24px;
    width: 200px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
